import {
    gettext,
    lazyGettext,
} from '../translations';

import {
    ORGANIZER_POPULAR_CATEGORIES,
} from 'consumer-utils/constants/categories';

import {
    // bucket keys
    ORGANIZERS_TO_FOLLOW,
    PRIMARY_BUCKET,
    SECONDARY_BUCKET,
    FIVE_TO_FOLLOW_IN_MUSIC,

    // feature flags
    LAUNCH_FIVE_TO_FOLLOW_BUCKET,
} from './constants';
import {constants as destinationConstants} from '@eb/destination-utils';

const {
    MUSIC: MUSIC_TAB,
    MUSIC_EVENTBRITE_CATEGORY,
    FOOD: FOOD_TAB,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    CHARITY: CHARITY_TAB,
    CHARITY_EVENTBRITE_CATEGORY,
    CURRENT_FUTURE,
    DATES_MAPPING,
    PRICE_MAPPING,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING,
} = destinationConstants;

export const ALL_TAB = 'all';
export const THIS_WEEKEND_TAB = 'this_weekend';
export const FREE_TAB = 'free';
export const FOR_YOU = 'for_you';

const MUSIC_TAB_NAME = EVENTBRITE_CATEGORY_MAPPING[MUSIC_EVENTBRITE_CATEGORY];
const MUSIC_TAB_NAME_LOWER = EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[MUSIC_EVENTBRITE_CATEGORY];

const FOOD_TAB_NAME = EVENTBRITE_CATEGORY_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY];
const FOOD_TAB_NAME_LOWER = EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY];

const CHARITY_TAB_NAME = EVENTBRITE_CATEGORY_MAPPING[CHARITY_EVENTBRITE_CATEGORY];
const CHARITY_TAB_NAME_LOWER = EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[CHARITY_EVENTBRITE_CATEGORY];

export const FEED_TABS = [
    ALL_TAB,
    FOR_YOU,
    THIS_WEEKEND_TAB,
    FREE_TAB,
    MUSIC_TAB,
    FOOD_TAB,
    CHARITY_TAB,
];

export const TABS_CONFIG = {
    [ALL_TAB]: {
        tabKey: 'All',
        name: lazyGettext('All'),
        eventSearch: {
            'dates': [CURRENT_FUTURE],
        },
        follow: ORGANIZER_POPULAR_CATEGORIES,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
            },
            [ORGANIZERS_TO_FOLLOW]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('Organizers to follow'),
                },
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                orderAfter: [ORGANIZERS_TO_FOLLOW],
                propsOverwrite: {
                    name: lazyGettext('More events'),
                },
            },
        },
    },
    [FOR_YOU]: {
        tabKey: FOR_YOU,
        name: lazyGettext('For you'),
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: lazyGettext('My liked events'),
                },
            },
            [ORGANIZERS_TO_FOLLOW]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('Organizers to follow'),
                },
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
        },
    },
    [THIS_WEEKEND_TAB]: {
        tabKey: 'This weekend',
        name: DATES_MAPPING[THIS_WEEKEND_TAB],
        eventSearch: {
            'dates': [CURRENT_FUTURE, 'this_weekend'],
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('More events this weekend'),
                },
            },
        },
    },
    [FREE_TAB]: {
        tabKey: 'Free',
        name: PRICE_MAPPING[FREE_TAB],
        eventSearch: {
            'dates': [CURRENT_FUTURE],
            'price': FREE_TAB,
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('More free events'),
                },
            },
        },
    },
    [MUSIC_TAB]: {
        tabKey: 'Music',
        name: MUSIC_TAB_NAME,
        eventSearch: {
            'dates': [CURRENT_FUTURE],
            'tags': MUSIC_EVENTBRITE_CATEGORY,
        },
        follow: [MUSIC_EVENTBRITE_CATEGORY],
        hasFiveToFollow: true,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
            },
            [ORGANIZERS_TO_FOLLOW]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('Organizers to follow'),
                },
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [FIVE_TO_FOLLOW_IN_MUSIC]: {
                order: 4,
                featureFlagName: LAUNCH_FIVE_TO_FOLLOW_BUCKET,
                propsOverwrite: {
                    name: lazyGettext('Five to follow in music'),
                },
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames: 'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames: 'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {tabName: MUSIC_TAB_NAME_LOWER}),
                },
            },
        },
    },
    [FOOD_TAB]: {
        tabKey: 'Food and drink',
        name: FOOD_TAB_NAME,
        eventSearch: {
            'dates': [CURRENT_FUTURE],
            'tags': FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        },
        follow: [FOOD_AND_DRINK_EVENTBRITE_CATEGORY],
        hasFiveToFollow: true,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
            },
            [ORGANIZERS_TO_FOLLOW]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('Organizers to follow'),
                },
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {tabName: FOOD_TAB_NAME_LOWER}),
                },
            },
        },
    },
    [CHARITY_TAB]: {
        tabKey: 'Charity',
        name: CHARITY_TAB_NAME,
        eventSearch: {
            'dates': [CURRENT_FUTURE],
            'tags': CHARITY_EVENTBRITE_CATEGORY,
        },
        follow: [CHARITY_EVENTBRITE_CATEGORY],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
            },
            [ORGANIZERS_TO_FOLLOW]: {
                order: 2,
                propsOverwrite: {
                    name: lazyGettext('Organizers to follow'),
                },
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                orderAfter: [ORGANIZERS_TO_FOLLOW],
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {tabName: CHARITY_TAB_NAME_LOWER}),
                },
            },
        },
    },
};
